export default function buildAdminWorkflowsQuery(searchParams) {
  const params = new URLSearchParams(
    typeof searchParams === "string" ? searchParams : searchParams?.toString?.() || ""
  );
  const q = new URLSearchParams();

  const status = params.get("status");
  if (status && ["published", "draft", "deprecated", "all"].includes(status) && status !== "all") {
    q.set("status", status);
  }

  const type = params.get("type");
  if (type && ["standard", "self_startable", "user", "all"].includes(type) && type !== "all") {
    q.set("type", type);
  }

  const hasPendingDraft = params.get("has_pending_draft");
  if (hasPendingDraft === "1") q.set("has_pending_draft", "1");

  const tagStatus = params.get("tag_status");
  if (tagStatus === "unscoped") q.set("tag_status", "unscoped");

  // Scope the list to one asset's tag coverage, so the task assignment wizard can't offer a
  // workflow the assignment endpoint would reject. Only a positive integer is forwarded —
  // anything else is dropped rather than passed through, because the server fails closed on an
  // unresolvable asset_id and a malformed value would read as "no workflows available".
  const assetId = params.get("asset_id");
  if (assetId && /^\d+$/.test(assetId) && Number(assetId) > 0) q.set("asset_id", assetId);

  return q.toString();
}
